module.exports = __webpack_public_path__ + "img/forex-money-markets.ac94cbde.jpg";